module.exports = __webpack_public_path__ + "static/media/reply-comment.0ee9015c.svg";